export default {
    /**
     * @param type { string } 要验证的字符串的类型 
     * @param str { string } 要验证的字符串
     * @example this.pub_fun.check_regular('phone','13190760326')
     * @returns { boolean } 正则，对应type验证对应str，通过返回true，反之返回false
     */
    check_regular : (type, str) => {
        switch (type){
            case 'phone' : 
                return /^[1][3,4,5,7,8][0-9]{9}$/.test(str);     // 手机号
            default:
                return false;     // 默认值，如果都不匹配，返回false
        }
    },

    /**
     * @param arr { array } 数组
     * @param val { string } 值
     * @example this.pub_fun.contains(数组,值)
     * @returns { boolean } 判断这个值是否在数组中，存在返回true，反之返回false
     */
    contains : (arr, val) => {     // 判断值是否在这个数组中
        return arr.indexOf(val) != -1 ? true : false;
    },

    /**
     * @param arr { number } 数值
     * @example this.pub_fun.yuanToCent(数值)
     * @returns { number } 金额，元转分
     */
    yuanToCent : (number) => {     // 判断值是否在这个数组中
        number = parseFloat(number + '')
        if (isNaN(number)) {
            return 0
        }
        let arg1 = number
        let arg2 = 100
        var m=0,s1=arg1.toString(),s2=arg2.toString();
        try{m+=s1.split(".")[1].length}catch(e){};
        try{m+=s2.split(".")[1].length}catch(e){};
        return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
    },

    /**
     * @param arr { number } 数值
     * @example this.pub_fun.centToYuan(数值)
     * @returns { number } 金额，元转分
     */
    centToYuan : (number) => {     // 判断值是否在这个数组中
        number = parseFloat(number + '')
        if (isNaN(number)) {
            return '0.00'
        }
        let arg1 = number
        let arg2 = 0.01
        var m=0,s1=arg1.toString(),s2=arg2.toString();
        try{m+=s1.split(".")[1].length}catch(e){};
        try{m+=s2.split(".")[1].length}catch(e){};
        let x =  Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);

        var f = parseFloat(x);
        var f = Math.round(x * 100) / 100;
        var s = f.toString();
        var rs = s.indexOf('.');
        if (rs < 0) {
            rs = s.length;
            s += '.';
        }
        while (s.length <= rs + 2) {
            s += '0';
        }
        return s;
    }
}